// Astrea Ops - "Check dates online" (v7.94, 19 Oct 2026).
//
// Asks /api/ai-date-check for a program's officially published dates. The app compares them
// with the project's event dates and saves the result on the project (dateCheck in src/App.jsx).
import { authHeaders } from './apiAuth';

export async function checkProgramDates({ name, year = '', client = '', venue = '', location = '' }, { signal } = {}) {
  const r = await fetch('/api/ai-date-check', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ name, year, client, venue, location }),
    signal,
  });
  let data = {};
  try { data = await r.json(); } catch (e) { data = {}; }
  if (!r.ok) throw new Error(data.error || ('The online check failed (HTTP ' + r.status + ').'));
  return {
    found: !!data.found,
    programName: data.programName || '',
    startDate: data.startDate || '',
    endDate: data.endDate || '',
    venue: data.venue || '',
    city: data.city || '',
    matchNote: data.matchNote || '',
    sourcesUsed: Array.isArray(data.sourcesUsed) ? data.sourcesUsed : [],
  };
}
